import React from "react";
import Hero from "./Hero";
import Categories from "./Categories";
import FeaturedListings from "./FeaturedListings";
import WhyChoose from "./WhyChoose";
import Testimonials from "./Testimonials";
import Footer from "./Footer";
import Navber from "../Common Component/Navber.jsx"
import FeaturedSales from "./FeaturedSales.jsx";
import FeaturedRental from "./FeaturedRental.jsx";
import ButtomLayout from "./ButtomLayout.jsx";


const Homemain = () => {
  return (
    <>
     <Navber/>
      <Hero />
      <Categories/>
      <FeaturedSales />
      <FeaturedRental/>
      <ButtomLayout/>
      <FeaturedListings />
      <WhyChoose />
      <Testimonials />
      <Footer />
    </>
  );
};

export default Homemain;
